


































































































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { State, Action, Getter, Mutation } from 'vuex-class'
import { validationMixin } from 'vuelidate'
import { required, email, minLength, maxLength } from 'vuelidate/lib/validators'
import { Seller, Auth0UserProfile } from '@/types'
import { SellersState } from '@/store/sellers/types'
import _get from 'lodash/get'
import _keys from 'lodash/keys'
import _toLower from 'lodash/toLower'

const namespace: string = 'sellers'
const formFieldKeys = [
  'email',
  'name',
  'address1',
  'address2',
  'city',
  'state',
  'zip',
  'phoneNumber',
  'buyerUserId',
  'contactName', // in User model
]

@Component({
  mixins: [validationMixin],
  validations: {
    form: {
      name: {
        required,
      },
      contactName: {
        required,
      },
      email: {
        required,
        email,
      },
      address1: {
        required,
      },
      city: {
        required,
      },
      state: {
        required,
      },
      zip: {
        required,
      },
      phoneNumber: {
        required,
      },
    },
  },
})
export default class SellerEdit extends Vue {
  @State('sellers') private sellersState: SellersState | undefined

  @Action('postSeller', { namespace }) private postSeller: any
  @Action('putSeller', { namespace }) private putSeller: any

  @Getter('getAuth0UserProfile', { namespace: 'auth' }) private userAuth0Profile:
    | Auth0UserProfile
    | undefined
  @Getter('getUserInfo', { namespace: 'auth' }) private userInfo: any
  @Getter('getEditSeller', { namespace }) private editSeller: Seller | undefined

  private form: any = {
    email: null,
    name: null,
    contactName: null,
    address1: null,
    address2: null,
    city: null,
    state: null,
    zip: null,
    phoneNumber: null,
  }
  private requestUpdateSeller: boolean = false

  private mounted(): void {
    for (const key of formFieldKeys) {
      this.form[key] =
        key === 'contactName'
          ? _get(this.editSeller, ['sellerUser', 'user', 'name']) || null
          : _get(this.editSeller, key) || null
    }
  }

  private getValidationClass(fieldName: string) {
    const field = this.$v.form[fieldName]
    return {
      'md-invalid': Boolean(field) && field?.$error,
    }
  }

  private clearForm() {
    this.$v.form.$reset()
    this.form.email = null
    this.form.name = null
    this.form.contactName = null
    this.form.address1 = null
    this.form.address2 = null
    this.form.city = null
    this.form.state = null
    this.form.zip = null
    this.form.phoneNumber = null
  }

  private onEnter(fieldName) {
    if (this.$v.form && this.$v.form[fieldName]) {
      ;(this.$v.form[fieldName] as any).$touch()
    }
  }

  private onSubmit() {
    const userRole = _toLower(_get(this.userInfo, ['role', 'name'])) || ''
    if (['buyer', 'buyer_admin', 'admin', 'super_admin'].indexOf(userRole) < 0) {
      Vue.$toast.error(
        `You don't have a permission to ${
          this.editSeller ? 'edit the' : 'add a'
        } seller. Please ask Admin about it.`
      )
      return
    }

    this.$v.form.$touch()
    if (!this.$v.form.$invalid) {
      const data = {
        buyerAuth0Id: _get(this.userAuth0Profile, ['auth0Id']) || '',
        ...this.form,
      }

      this.requestUpdateSeller = true

      if (this.editSeller) {
        this.putSeller({ id: this.editSeller!.id, data })
          .then(res => {
            this.$router.push({ name: 'Sellers' })
          })
          .catch(err => {})
          .finally(() => {
            this.requestUpdateSeller = false
          })
      } else {
        this.postSeller(data)
          .then(res => {
            this.$router.push({ name: 'Sellers' })
          })
          .catch(err => {})
          .finally(() => {
            this.requestUpdateSeller = false
          })
      }
    }
  }
}
